import { facilitiesFields } from '@lib/fragments/facilities';
import gql from 'graphql-tag';

const facilitiesSectionFragment = gql`
  fragment facilitiesSectionFields on FacilitiesSection {
    text
    title
    facilities {
      ${facilitiesFields}
    }
    backgroundColor: background_color {
      color
    }
  }
`;

export default facilitiesSectionFragment;
